<template>
  <div>
    <v-btn
      block
      color="primary darken-1"
      class="white--text"
      dark
      @click="loadAgents"
    >
      Bulk Assign
    </v-btn>
    <v-dialog v-model="open" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Assign agents</span>
        </v-card-title>
        <v-card-text>
          <v-select
            v-model="agent"
            :items="agents"
            item-text="title"
            item-value="id"
            label="Standard"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="() => (open = false)">
            Close
          </v-btn>
          <v-btn color="red darken-1" class="white--text" @click="assign">
            Assign
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AssignForm",
  data() {
    return {
      open: false,
      agent: null,
    };
  },
  methods: {
    ...mapActions({
      loadSuitableAgentsByStates: "agents/loadSuitableAgentsByStates",
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    assign() {
      this.$axios
        .post("/lead/reassign", { agent: this.agent, leads: this.selectedPool })
        .then((res) => {
          this.open = false;
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadAgents() {
      if (this.selectedPool.length > 0) {
        this.open = true;
        this.loadSuitableAgentsByStates(this.selectedPool);
      } else {
        this.showHandlerSnackbar({
          color: "red",
          text: "Please select the leads to be able to re-assign it!",
          show: true,
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      selectedPool: "leads/selectedPool",
      agents: "agents/suitableAgentsByStates",
    }),
  },
};
</script>

<style>
</style>